import angular from 'angular';
import whatIsSolidaryListComponent from './whatIsSolidaryList.component';

let whatIsSolidaryListModule = angular.module('whatIsSolidaryList', [
])

.component('whatIsSolidaryList', whatIsSolidaryListComponent)

.name;

export default whatIsSolidaryListModule;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/components/whatIsSolidaryEuro/whatIsSolidaryList/whatIsSolidaryList.js